import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Chevron, Collapse } from 'ui/acro/animations'
import { Flex, HR } from 'ui/acro/elements'
import { Header, P } from 'ui/acro/typography'

const FAQItem = ({ title, body, selected, handleSelect, index }) => (
  <Fragment>
    <Flex
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      onClick={() => handleSelect(index)}
      onKeyPress={() => handleSelect(index)}
      cursor='pointer'
      aria-controls={`faq-item-${index}`}
      aria-expanded={selected}
      tabIndex='0'
    >
      <Header color='primary' variant='semibold'>{title}</Header>
      <Chevron width='13px' height='100%' className={selected && 'flip'} />
    </Flex>
    <Collapse isOpened={selected}>
      <P pt='16px' pb={['2px', '4px']} color='grey5' id={`faq-item-${index}`} dangerouslySetInnerHTML={body} />
    </Collapse>
    <HR my='22px' />
  </Fragment>
)

FAQItem.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  handleSelect: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
}

export default FAQItem
